"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dangerCargo = require("@/api/dangerCargo/dangerCargo");
var _validate = require("@/utils/validate");
var _date = require("@/utils/date");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'dangerCargo',
  data: function data() {
    return {
      statusTypeName: {
        '0': '等待审批',
        '1': '通过',
        '2': '拒绝',
        '3': '草稿',
        '4': '作废'
      },
      statusTypeEN: {
        '0': 'Approvaling',
        '1': 'Pass',
        '2': 'Refuse',
        '3': 'Draft',
        '4': 'Nullify'
      },
      form: {
        refNo: '',
        pageSize: 300,
        rowStart: 1
      },
      isCnLang: false,
      refInfo: {
        refNo: undefined,
        status: undefined,
        voyage: undefined,
        pol: undefined,
        pod: undefined,
        isMix: undefined,
        applyPerson: undefined,
        applyDate: undefined,
        updatedDtmLoc: undefined,
        containerQuantity: undefined,
        classType: undefined,
        seriseNo: undefined
      },
      specialContainerInfo: {
        refNo: undefined,
        rowStatus: undefined,
        vesselCode: undefined,
        voyageNo: undefined,
        voyageLeg: undefined,
        pol: undefined,
        pod: undefined,
        applyPerson: undefined,
        applyDate: undefined,
        updatedDtmLoc: undefined
      },
      isResult: false,
      loading: null,
      rules: {
        refNo: [{
          required: true,
          message: this.$t('titleSearch.validateNullRefNo'),
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    validateNull: _validate.validateNull,
    dateFormat: _date.dateFormat,
    toSearch: function toSearch() {
      var _this = this;
      this.$refs.form.validate(function (vaild) {
        if (vaild) {
          _this.loading = (0, _utils.load)();
          (0, _dangerCargo.dangerCargoSearch)(_this.form).then(function (response) {
            if (!(0, _validate.validateNull)(response.data.list)) {
              _this.refInfo = response.data.list;
              _this.isResult = true;
            } else {
              _this.refInfo = [];
              _this.isResult = true;
            }
          }).catch(function () {
            _this.refInfo = [];
            _this.isResult = true;
          }).finally(function () {
            _this.loading.close();
          });
          _this.loading = (0, _utils.load)();
          (0, _dangerCargo.getByRefNo)(_this.form.refNo).then(function (response) {
            if (!(0, _validate.validateNull)(response.data)) {
              _this.specialContainerInfo = response.data;
              _this.isResult = true;
            } else {
              _this.specialContainerInfo = [];
              _this.isResult = true;
            }
          }).catch(function () {
            _this.specialContainerInfo = [];
            _this.isResult = true;
          }).finally(function () {
            _this.loading.close();
          });
        }
      });
    },
    formatDate: function formatDate(row, column, cellValue, index) {
      row.applyDate = (0, _date.dateFormat)('YYYY-MM-DD', row.applyDate);
      return row.applyDate;
    },
    formatDate1: function formatDate1(row, column, cellValue, index) {
      row.updatedDtmLoc = (0, _date.dateFormat)('YYYY-MM-DD', row.updatedDtmLoc);
      return row.updatedDtmLoc;
    }
  },
  created: function created() {
    this.isCnLang = this.$i18n.locale === 'zh';
  }
};